// extracted by mini-css-extract-plugin
module.exports = {"layoutSpacing":"styles_layoutSpacing__ge7jr"};